import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-layout',
  templateUrl: './external-layout.component.html',
  styleUrls: ['./external-layout.component.scss']
})
export class ExternalLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
